























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ActionMethod } from 'vuex';
import { Action, Getter } from 'vuex-class';
import SvgIcon from '@/components/SvgIcon.vue';
import TooltipCircle from '@/components/molecules/TooltipCircle/index.vue';
import DpButton from '@/components/atoms/DpButton/index.vue';
import ApplicationActionTypes from '@/modules/application/ApplicationActionTypes';
import AirbnbFromIgmsService from '@/common/services/PMS/AirbnbFromIgmsService';
import { PlatformActionTypes } from '@/modules/platform/module';

@Component({
  name: 'PerformanceWidget',
  components: {
    SvgIcon,
    TooltipCircle,
    DpButton,
  },
})
export default class PerformanceWidget extends Vue {
  @Action(ApplicationActionTypes.PUSH_ROUTE, { namespace: 'application' })
  protected dispatchPushRoute!: ActionMethod;

  @Action(PlatformActionTypes.SET_STEP_VERIFY_AIRBNB, { namespace: 'platform' })
  protected dispatchSetStepVerifyAirbnb: any;

  @Prop() title!: string;

  @Prop() tooltipText!: string;

  @Prop({ default: false }) protected loading!: any;

  @Prop() protected description!: string;

  @Prop({ default: false }) locked!: boolean;

  @Prop({ default: false }) hasEdit!: boolean;

  @Prop({ default: false }) editRoute!: any;

  @Prop({ default: false }) textLightColor!: boolean;

  @Prop({ default: false }) isDataMiningAndAnalysis!: boolean;

  @Prop({ default: false }) isComingSoon!: boolean;

  @Prop({ default: false }) isWidgetSmall!: boolean;

  @Prop() listing!: any;

  @Getter('user', { namespace: 'auth' }) protected user?: any;

  protected get isUnverifiedLocked() {
    return this.listing && !this.listing.isVerified;
  }

  protected onVerify = () => {
    // if (this.user && this.user.email.includes('test@test1.com')) {
    AirbnbFromIgmsService.connect();
    // } else {
    //   this.dispatchSetStepVerifyAirbnb({
    //     accountUuid: this.listing.accountUuid,
    //   });
    // }
  }

  protected onClick() {
    if (this.hasEdit) {
      this.dispatchPushRoute(this.editRoute);
    }
  }

  protected onClickUnlock() {
    this.$emit('onClickUnlock');
  }
}
